<template>
  <ReportAgent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import ReportAgent from "@/own/components/reports/ReportAgent.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "ReportOrderCycle",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/reportOrderCycle",
      show_url: "/reports/reportOrderCycle/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
